export default "__VITE_ASSET__xFyEjKCE__"